/** @format */

import React, {useContext, useState} from 'react'

import ajax from '../../ajax'
import {AccountContext} from '../../contexts/AccountContext'
import {LoadingContext} from '../../contexts/LoadingContext'
import LoaderButton from './LoaderButton'
import Modal from './Modal'
import {ContextModal} from './ModalContext'

export default function CancelModal({onSuccess, modal, ...rest}) {
  const {sub, reloadAccount} = useContext(AccountContext)
  const {ready} = useContext(LoadingContext)
  const [reason, setReason] = useState('')

  const cancelSubscription = async e => {
    e.preventDefault()

    await ajax({
      endpoint: '/api-int/cancel',
      payload: {why: reason},
      onSuccess: async () => {
        onSuccess()
        await reloadAccount()
      },
      errorMsg: 'Failed to cancel subscription.',
      successMsg: r => {
        return (
          'Subscription canceling. <br>' +
          `Your subscription will remain active until ${r.at}`
        )
      }
    })

    ready()
  }

  function renderForm() {
    return (
      <form
        action="/api-int/cancel"
        method="POST"
        onSubmit={cancelSubscription}
        className={'w-full'}
      >
        <p className={'mb-2'}>
          This will cancel your subscription at the end of your current billing
          cycle
          {sub ? ' on ' + sub.current_period_end : ''}. Your account will remain
          active until then.
        </p>
        <label className={'block'}>
          <p className={'font-bold mb-2'}>Why are you canceling?</p>
          <textarea
            placeholder="Was it a missing feature? Bad service? Just don't need us anymore?"
            value={reason}
            onChange={e => setReason(e.target.value)}
            className={'h-32'}
          />
        </label>
        <div className="mt-6">
          <LoaderButton
            disabled={!reason || reason.trim() === ''}
            className={'float-right'}
            type="submit"
          >
            Cancel Subscription
          </LoaderButton>
        </div>
      </form>
    )
  }
  return modal ? (
    <ContextModal modal={modal} title={'Cancel Subscription'} {...rest}>
      {renderForm()}
    </ContextModal>
  ) : (
    <Modal title={'Cancel Subscription'} {...rest}>
      {renderForm()}
    </Modal>
  )
}
